module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wscn-http401-container"
  }, [_c('div', {
    staticClass: "wscn-http401"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bullshit"
  }, [_c('div', {
    staticClass: "bullshit__oops"
  }, [_vm._v("OOPS!")]), _vm._v(" "), _c('div', {
    staticClass: "bullshit__info"
  }), _vm._v(" "), _c('div', {
    staticClass: "bullshit__headline"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', {
    staticClass: "bullshit__info"
  }), _vm._v(" "), _c('a', {
    staticClass: "bullshit__return-home",
    attrs: {
      "href": ""
    }
  }, [_vm._v("Home")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic-401"
  }, [_c('img', {
    staticClass: "pic-401__parent",
    attrs: {
      "src": "@/assets/401_images/401.png",
      "alt": "401"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pic-401__child left",
    attrs: {
      "src": "@/assets/401_images/401_cloud.png",
      "alt": "401"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pic-401__child mid",
    attrs: {
      "src": "@/assets/401_images/401_cloud.png",
      "alt": "401"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pic-401__child right",
    attrs: {
      "src": "@/assets/401_images/401_cloud.png",
      "alt": "401"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-973f162c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/errorPage/401.vue
// module id = 607
// module chunks = 2